import Layout from '../components/Layout';
// import TasksInterface from '../components/TasksInterface';
import TaskManagement from '../components/TaskManagement';
import Pageheader from '../utils/headerHelment';

const TasksInterfaceView = () => {
    return (
        <>
            <Pageheader title="LENS - Project Management" />
            <TaskManagement />
        </>
    );
};

export default TasksInterfaceView;
